import api from './api.js';

export const attendanceService = {
  // Get my attendance (student)
  getMyAttendance: (params = {}) => api.get('/attendance/my-attendance', { params }),
  
  // Get student attendance (teacher/parent)
  getStudentAttendance: (studentId, params = {}) => 
    api.get(`/attendance/student/${studentId}`, { params }),
  
  // Get class attendance (teacher only)
  getClassAttendance: (classId, params = {}) => 
    api.get(`/attendance/class/${classId}`, { params }),
  
  // Mark attendance (teacher only)
  markAttendance: (data) => api.post('/attendance/mark', data),
  
  // Update attendance (teacher only)
  updateAttendance: (attendanceId, data) => 
    api.put(`/attendance/${attendanceId}`, data),
  
  // Bulk mark attendance (teacher only)
  bulkMarkAttendance: (data) => api.post('/attendance/bulk-mark', data),
  
  // Get attendance by date
  getAttendanceByDate: (date, params = {}) => 
    api.get(`/attendance/date/${date}`, { params }),
  
  // Get attendance by month
  getAttendanceByMonth: (year, month, params = {}) => 
    api.get(`/attendance/month/${year}/${month}`, { params }),
  
  // Get attendance statistics
  getAttendanceStats: (params = {}) => api.get('/attendance/stats', { params }),
  
  // Get student attendance stats
  getStudentAttendanceStats: (studentId, params = {}) => 
    api.get(`/attendance/student/${studentId}/stats`, { params }),
  
  // Get class attendance stats (teacher only)
  getClassAttendanceStats: (classId, params = {}) => 
    api.get(`/attendance/class/${classId}/stats`, { params }),
  
  // Get attendance trends
  getAttendanceTrends: (params = {}) => api.get('/attendance/trends', { params }),
  
  // Get attendance calendar
  getAttendanceCalendar: (studentId, year, month) => 
    api.get(`/attendance/calendar/${studentId}/${year}/${month}`),
  
  // Get my attendance calendar (student)
  getMyAttendanceCalendar: (year, month) => 
    api.get(`/attendance/my-calendar/${year}/${month}`),
  
  // Get children attendance calendar (parent)
  getChildrenAttendanceCalendar: (year, month) => 
    api.get(`/attendance/children-calendar/${year}/${month}`),
  
  // Export attendance (teacher only)
  exportAttendance: (params = {}) => api.get('/attendance/export', { 
    params, 
    responseType: 'blob' 
  }),
  
  // Get attendance summary
  getAttendanceSummary: (params = {}) => api.get('/attendance/summary', { params }),
  
  // Get late arrivals
  getLateArrivals: (params = {}) => api.get('/attendance/late-arrivals', { params }),
  
  // Get early departures
  getEarlyDepartures: (params = {}) => api.get('/attendance/early-departures', { params }),
  
  // Get absent students
  getAbsentStudents: (date) => api.get(`/attendance/absent/${date}`),
  
  // Get attendance alerts
  getAttendanceAlerts: (params = {}) => api.get('/attendance/alerts', { params }),
  
  // Mark attendance alert as read
  markAlertAsRead: (alertId) => api.put(`/attendance/alerts/${alertId}/read`),
  
  // Get attendance patterns
  getAttendancePatterns: (studentId, params = {}) => 
    api.get(`/attendance/student/${studentId}/patterns`, { params }),
  
  // Get attendance reports
  getAttendanceReports: (params = {}) => api.get('/attendance/reports', { params }),
  
  // Generate attendance report
  generateAttendanceReport: (data) => api.post('/attendance/generate-report', data),
};
